<template>
  <svg width="20" height="20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.39 2.5H3.64A1.095 1.095 0 0 0 2.5 3.58v12.84a1.095 1.095 0 0 0 1.11 1.08h12.75a1.097 1.097 0 0 0 1.14-1.08V3.58a1.095 1.095 0 0 0-1.11-1.08ZM6.947 15.25H4.75V8.124H7l-.053 7.124Zm-1.11-8.107a1.29 1.29 0 0 1-.255-2.553 1.29 1.29 0 0 1 .75 2.455 1.29 1.29 0 0 1-.494.098Zm9.413 8.106H13V11.8c0-.832 0-1.896-1.155-1.896s-1.335.907-1.335 1.837v3.51H8.26V8.124h2.138V9.1a2.34 2.34 0 0 1 2.1-1.155c2.25 0 2.67 1.5 2.67 3.412l.082 3.892Z"
      fill="currentColor"
    />
  </svg>
</template>
